const DEMO_DATA_URLS = {
  HourlyApps: '/demo-data/hourlyapps_clean_data.json',
  MinuteApps: '/demo-data/minuteapps_clean_data.json',
  DailyApps: '/demo-data/dailyapps_data.json',
} as const;

export const fetchTestData = async (type: string) => {
  const url =
    type === 'HourlyApps'
      ? DEMO_DATA_URLS.HourlyApps
      : type === 'MinuteApps'
        ? DEMO_DATA_URLS.MinuteApps
        : DEMO_DATA_URLS.DailyApps;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load demo data: ${response.status}`);
  }
  return response.json();
};
